// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file auth/get_pharmacy_info.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PharmacyLocationDetails, PharmacyMetadata, PharmacySettings, PharmacySetupDetails, PharmacySize, PharmacyStatus, StockPointType } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetPharmacyInfoRequest
 */
export class GetPharmacyInfoRequest extends Message<GetPharmacyInfoRequest> {
  /**
   * Unique identifier for the pharmacy
   *
   * @generated from field: string pharmacy_code = 1;
   */
  pharmacyCode = "";

  /**
   * Unique identifier for the company
   *
   * @generated from field: string company_code = 2;
   */
  companyCode = "";

  /**
   * Unique identifier for the stock point
   *
   * @generated from field: string stock_point_id = 3;
   */
  stockPointId = "";

  constructor(data?: PartialMessage<GetPharmacyInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPharmacyInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pharmacy_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPharmacyInfoRequest {
    return new GetPharmacyInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPharmacyInfoRequest {
    return new GetPharmacyInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPharmacyInfoRequest {
    return new GetPharmacyInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPharmacyInfoRequest | PlainMessage<GetPharmacyInfoRequest> | undefined, b: GetPharmacyInfoRequest | PlainMessage<GetPharmacyInfoRequest> | undefined): boolean {
    return proto3.util.equals(GetPharmacyInfoRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetPharmacyInfoResponse
 */
export class GetPharmacyInfoResponse extends Message<GetPharmacyInfoResponse> {
  /**
   * Name of the pharmacy
   *
   * @generated from field: string pharmacy_name = 1;
   */
  pharmacyName = "";

  /**
   * Name of the company
   *
   * @generated from field: string company_name = 2;
   */
  companyName = "";

  /**
   * Name of the stock point
   *
   * @generated from field: string stock_point_name = 3;
   */
  stockPointName = "";

  /**
   * Unique identifier for the pharmacy
   *
   * @generated from field: string pharmacy_code = 4;
   */
  pharmacyCode = "";

  /**
   * Unique identifier for the company
   *
   * @generated from field: string company_code = 5;
   */
  companyCode = "";

  /**
   * Unique identifier for the stock point
   *
   * @generated from field: string stock_point_id = 6;
   */
  stockPointId = "";

  /**
   * Size of the pharmacy
   *
   * @generated from field: com.neulink.pharmacy.PharmacySize size = 7;
   */
  size = PharmacySize.SIZE_UNSPECIFIED;

  /**
   * Additional metadata about the pharmacy
   *
   * @generated from field: com.neulink.pharmacy.PharmacyMetadata metadata = 8;
   */
  metadata?: PharmacyMetadata;

  /**
   * Location details of the pharmacy
   *
   * @generated from field: com.neulink.pharmacy.PharmacyLocationDetails location_details = 9;
   */
  locationDetails?: PharmacyLocationDetails;

  /**
   * Settings related to the pharmacy
   *
   * @generated from field: com.neulink.pharmacy.PharmacySettings settings = 10;
   */
  settings?: PharmacySettings;

  /**
   * Status of the pharmacy
   *
   * @generated from field: com.neulink.pharmacy.PharmacyStatus status = 11;
   */
  status = PharmacyStatus.STATUS_UNKNOWN;

  /**
   * Type of the stock point
   *
   * @generated from field: com.neulink.pharmacy.StockPointType stock_point_type = 12;
   */
  stockPointType = StockPointType.UNKNOWN;

  /**
   * Setup details of the pharmacy
   *
   * @generated from field: com.neulink.pharmacy.PharmacySetupDetails setup_details = 13;
   */
  setupDetails?: PharmacySetupDetails;

  constructor(data?: PartialMessage<GetPharmacyInfoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPharmacyInfoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pharmacy_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "stock_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "pharmacy_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "company_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "size", kind: "enum", T: proto3.getEnumType(PharmacySize) },
    { no: 8, name: "metadata", kind: "message", T: PharmacyMetadata },
    { no: 9, name: "location_details", kind: "message", T: PharmacyLocationDetails },
    { no: 10, name: "settings", kind: "message", T: PharmacySettings },
    { no: 11, name: "status", kind: "enum", T: proto3.getEnumType(PharmacyStatus) },
    { no: 12, name: "stock_point_type", kind: "enum", T: proto3.getEnumType(StockPointType) },
    { no: 13, name: "setup_details", kind: "message", T: PharmacySetupDetails },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPharmacyInfoResponse {
    return new GetPharmacyInfoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPharmacyInfoResponse {
    return new GetPharmacyInfoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPharmacyInfoResponse {
    return new GetPharmacyInfoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPharmacyInfoResponse | PlainMessage<GetPharmacyInfoResponse> | undefined, b: GetPharmacyInfoResponse | PlainMessage<GetPharmacyInfoResponse> | undefined): boolean {
    return proto3.util.equals(GetPharmacyInfoResponse, a, b);
  }
}

